import axios, { AxiosError } from 'axios';
import { makeUseAxios } from 'axios-hooks';
import config from './config';
import HttpStatusCode from './HttpStatusCode';
import { renderErrors } from '../error-message-helper';
import localKey from '../../storage/localKey';
import { routes } from '../../navigation/appRoutes';



export const customAxios = axios.create({
  baseURL: config.API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});


customAxios.interceptors.request.use(
  async (config) => {
    const accessToken = await localStorage.getItem(localKey.AUTH_TOKEN);
    const accessTokenTemp = await localStorage.getItem(localKey.TEMP_AUTH_TOKEN);
    if (accessToken && config.headers) {
      config.headers['Authorization'] = 'Bearer ' + accessToken;
      config.headers['OffSetMins'] = (-(new Date().getTimezoneOffset()));
    }else if(accessTokenTemp && config.headers){
      config.headers['Authorization'] = 'Bearer ' + accessTokenTemp;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);


customAxios.interceptors.response.use(
  async (resp) => {
    if (localStorage.getItem(localKey.AUTH_TOKEN) && resp.data.statusCode && resp.data.statusCode == HttpStatusCode.UNAUTHORIZED) {
      sessionStorage.clear();
      localStorage.setItem("logout", Date.now().toString());
      localStorage.removeItem("logout");
      localStorage.clear();
      window.location.href = routes.auth;
      return null;
    }
    else if (resp.data.statusCode && resp.data.statusCode == HttpStatusCode.OK) {
      return resp.data
    }
    else {
      return resp.data;
    }
  },
  (error: AxiosError) => {
    try {
      if (error.response?.status) {
        // sessionStorage.clear();
        // localStorage.setItem("logout", Date.now().toString());
        // localStorage.removeItem("logout");
        // localStorage.clear();
        // window.location.href = routes.auth;
        // return null;
      }
    } catch (E) {
      Promise.reject(error);
    }

  }
);



export const useExpressApi = makeUseAxios({
  cache: false,
  axios: customAxios,
});

